import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';

import illustrationUrl from 'src/modules/insuranceIntegration/svg/ManBoxStepSVG.svg';
import { Button } from 'src/shared/components/Button';
import { Modal } from 'src/shared/components/Modal';
import { color, font } from 'src/shared/styles/variables';

const StyledModal = styled(Modal)({
    overflow: 'auto',
    borderRadius: 20,
    paddingBottom: 0,
});

const ContentWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '10%',
    marginRight: '10%',
    alignItems: 'center',
});

const StyledModalTitle = styled('h1')({
    color: color.ebonyClay,
    marginBottom: 20,
    textAlign: 'center',
    ...font.heavy(font.size.extraLarge),
});

const StyledPara = styled('p')({
    color: color.blueBayoux,
    marginBottom: 20,
    textAlign: 'center',
    ...font.book(font.size.medium),
});

const FloatingWomanWithPhoneIllustration = styled('div')({
    display: 'inline-block',
    width: 'calc(100% + 48px)',
    height: 226,
    marginBottom: 28,
    marginLeft: -24,
    backgroundImage: `url('${illustrationUrl}')`,
    backgroundSize: 'cover',
    backgroundPositionX: 'center',
});

export const CheckEligibilityTransitionModal = () => {
    const { t } = useTranslation();

    return (
        <StyledModal
            visible
            closable={false}
            maskClosable={false}
            footer={null}
            width={760}
            centered
        >
            <FloatingWomanWithPhoneIllustration />
            <ContentWrapper>
                <StyledModalTitle>
                    {t('insuranceForm:insurance_eligibility_transition.title')}
                </StyledModalTitle>
                <StyledPara>
                    {t('insuranceForm:insurance_eligibility_transition.just_booked_your_last')}
                </StyledPara>
                <StyledPara>
                    {t('insuranceForm:insurance_eligibility_transition.well_start_check')}
                </StyledPara>
                <Button to="/inquire-employer-insurance-coverage" type="accept">
                    {t('insuranceForm:insurance_eligibility_transition.check_therapy_eligibility')}
                </Button>
            </ContentWrapper>
        </StyledModal>
    );
};
